import { useLocation } from 'react-router-dom';
import { IonItem, IonGrid, IonRow, IonCol, IonImg, IonIcon } from '@ionic/react';
import { star, starOutline, bedOutline } from 'ionicons/icons';
import { MealPlans } from '../../defines/Functions';
import HotelDetails from './modals/HotelDetails';
import moment from 'jalali-moment';
import CurrencyFormat from 'react-currency-format';
import HotelMap from './modals/HotelMap';
import HotelRooms from './modals/HotelRooms';
import './HotelCard.css';
import mapImg from '../../assets/images/map.svg';
import eyeImg from '../../assets/images/eye.svg';

interface Props {
    data: any,
    id: number,
    hotelDefines: any,
    roomStays: any,
    hotelRoom?: any,
    codeParentCallback: Function,
    expireTime?: any
}
const HotelCard = (item: Props) => {
    let dateStart: any = moment(item.hotelDefines.all[0].dates.dates[0]).format("X");
    let dateEnd: any = moment(item.hotelDefines.all[0].dates.dates[1]).format("X");
    let dateDiff = Math.round((dateEnd - dateStart) / (60 * 60 * 24));
    let passengersCount = 0;
    item.hotelDefines.all[0].rooms.forEach((item: any) => {
        passengersCount += item.adults + item.childs;
    });
    const hotelCode = item.data.basicPropertyInfo.hotelCode;
    let hotelRoomsData = {
        correlationId: item.data.basicPropertyInfo.hotelCodeContext,
        hotelCode: item.data.basicPropertyInfo.hotelCode,
        startDate: item.hotelDefines.all[0].dates.dates[0],
        endDate: item.hotelDefines.all[0].dates.dates[1],
        cityName: item.hotelDefines.all[0].city.city_name,
        countryName: item.hotelDefines.all[0].city.country_code,
        citizenCountryName: item.hotelDefines.all[0].city.country_code,
        rooms: item.hotelDefines.all[0].rooms
    };
    const location = useLocation();
    const currentPage = location.pathname;
    const handleCodeCallback = (childData: any) => {
        item.codeParentCallback(childData);
    }
    return (
        <IonItem className="hotel-card-item" lines="none">
            <IonGrid>
                <IonRow className="row-1">
                    <IonCol size="6" className="col-1">
                        <IonImg src={item.data.hotelImage} />
                    </IonCol>
                    <IonCol size="6" className="col-2 ion-text-center">
                        <h5>
                            {item.data.hotelName}
                        </h5>
                        <span>
                            {[...Array(5)].map((_, index) =>
                                index + 1 <= item.data.basicPropertyInfo.award[0].rating ?
                                    <IonIcon icon={star} key={'index' + index} />
                                    :
                                    <IonIcon icon={starOutline} key={'index' + index} />
                            )}
                        </span>
                    </IonCol>
                </IonRow>
                <IonRow className="row-2">
                    <IonCol size="6" className="col-1">
                        <span>هزینه ی {dateDiff} شب برای {passengersCount} نفر</span>
                        <b>
                            <CurrencyFormat value={item.data.price[0].amountAfterTax} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                        </b>
                    </IonCol>
                    <IonCol size="6" className="col-2">
                        {currentPage === '/hotel/reservation' ?
                            <div className="dates">
                                <span>
                                    از {moment(item.hotelDefines.all[0].dates.dates[0]).locale('fa').format('dddd D MMMM YYYY')}
                                    <br />
                                    ({item.hotelDefines.all[0].dates.dates[0]})
                                </span>
                                <span>
                                    تا {moment(item.hotelDefines.all[0].dates.dates[1]).locale('fa').format('dddd D MMMM YYYY')}
                                    <br />
                                    ({item.hotelDefines.all[0].dates.dates[1]})
                                </span>
                            </div>
                            :
                            <HotelRooms data={hotelRoomsData} item={item} closeHotelMap={() => { }} expireTime={item.expireTime} />
                        }
                    </IonCol>
                    {currentPage === '/hotel/reservation' &&
                        <IonCol size="12" className="col-3">
                            <b>اتاق ها</b>
                            {item.hotelRoom !== undefined &&
                                item.hotelRoom.map((item: any, index: number) =>
                                    <span key={"index" + index}>
                                        <IonIcon icon={bedOutline} />
                                        {item.rms.roomTypes.roomType[0].tpaextensions !== undefined && item.rms.roomTypes.roomType[0].tpaextensions.any[0].persianRoomType ?
                                            item.rms.roomTypes.roomType[0].tpaextensions.any[0].persianRoomType
                                            :
                                            item.rms.roomTypes.roomType[0].roomType
                                        } - {MealPlans(item.rms.roomRates.roomRate[0].ratePlanID)}
                                    </span>
                                )
                            }
                        </IonCol>
                    }
                </IonRow>
                <IonRow className="row-3">
                    <IonCol size="6" className="ion-text-center col-1">
                        <IonIcon icon={eyeImg} />
                        <HotelDetails hotelCode={hotelCode} data={hotelRoomsData} item={item} />
                    </IonCol>
                    <IonCol size="6" className="ion-text-center col-2">
                        <IonIcon icon={mapImg} />
                        <HotelMap data={[item.data]} roomData={hotelRoomsData} item={item} codeParentCallback={handleCodeCallback} />
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonItem>
    );
};
export default HotelCard;